import { h, Component } from 'preact';
import BankLists from './BankLists';
import { staticPath } from '../../utils/common';
import OverlayWrap from '../OverlayWrap';
import { EVENT, log } from '../../common/logger';

export default class BankListsWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = { searchValue: '' };
  }

  searchBank = e => {
    log({ eventType: EVENT.NB_SEARCH_BAR_USED });
    if (e && e.target) {
      this.setState({ searchValue: e.target.value });
    }
    this.props.filterBanks(e);
  };

  clearSearchValue = () => {
    this.setState({ searchValue: '' });
    this.props.clearSeacrh();
  };

  render(
    {
      bankListsData,
      cancel,
      BankOptionClick,
      filterBankData,
      showFilteredData,
      alphabetFilter,
      isSearchFocused,
      focusIn
    },
    { searchValue }
  ) {
    return (
      <div className={`ptm-nb-bank-wrap ptm-pos-a`} id="checkout-nb-banks">
        <OverlayWrap>
          <div className={`ptm-nb-dropdown-wrap`}>
            <div className={`ptm-nb-dropdown-header ${isSearchFocused ? 'ptm-focused-state' : ''}`}>
              <div className={`nb-inputarea`}>
                <span className={`ptm-cross ptm-pos-r ptm-black`} onClick={() => cancel()} />
                <span className={`ptm-select-bank ptm-body-color`}>Select Bank</span>
                <div className={`ptm-nb-boxinput ptm-pos-r`}>
                  <input
                    type="text"
                    id="searchBar"
                    className={` ptm-margin0 ptm-dropdown-input ptm-input-common`}
                    onFocusIn={() => focusIn()}
                    placeholder="Search"
                    onKeyUp={this.searchBank}
                    value={searchValue}
                  />
                  <img
                    className={`ptm-search-img ptm-pos-a`}
                    src={`${staticPath()}/assets/images/search-icon.svg`}
                    alt=""
                  />
                </div>
                <button
                  className={`ptm-nb-cancel ptm-primary ptm-pos-a ptm-nb-cancel-btn ptm-hidden`}
                  onClick={this.clearSearchValue}
                >
                  Cancel
                </button>
              </div>
            </div>
            {/* selection of bank */}
            <BankLists
              bankListsData={bankListsData}
              filterBankData={filterBankData}
              cancel={this.cancel}
              BankOptionClick={BankOptionClick}
              showFilteredData={showFilteredData}
              alphabetFilter={alphabetFilter}
            />
          </div>
        </OverlayWrap>
        {/* <div className={`ptm-overlay-black`}></div> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/nb/BankListsWrapper.js